<app-form-input

[label]="labelRadio"
[name]="radioButtonCtrlName"
[value]="radioButtonValue"
[parentForm]="parentForm"
[disabled]="disabled"

[type]="'radio'"
[rule]="'pattern_29|required'"
[errorMessage]="{'required' : 'ctr_1203'}"
[radios]="[
    {
        value: 'Oui',
        label: step3.getoui
    },
    {
        value: 'Non',
        label: step3.getnon
    }
]"
>
</app-form-input>


 <!--<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="typeOuiNon.oui"

[label]="'oui'"
[type]="'tofix'" [rule]="''"
[name]="getUid()+'_SepAtt_oui'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="typeOuiNon.non"

[label]="'non'"
[type]="'tofix'" [rule]="''"
[name]="getUid()+'_SepAtt_non'">
</app-form-input>-->
